// Signal strip: radio link (uplink/downlink) and GPS quality, slaved to the
// profile. Uplink and downlink share a fixed 0-100 axis so they read against
// each other; satellite count has its own scale and a dashed line to say so.
// Pips come from the GPS/signal warning events on the flight, so the same
// dropouts appear here, in the warnings list and in the table.

import { Strip } from './strip.js';

export class SignalChart extends Strip {
  storageKey() { return 'ddlv-signal-series'; }
  ariaLabel() { return 'Signal timeline'; }

  series() {
    return [
      { id: 'satellites', key: 'satellites', label: 'satellites', colour: 'var(--trace)', min: 0, dash: '3 3', opacity: 0.85, fmt: (v) => `${Math.round(v)}` },
      { id: 'uplink', key: 'uplinkSignalPct', label: 'uplink', unit: '%', colour: 'var(--ok)', min: 0, max: 100, opacity: 0.9, fmt: (v) => `${Math.round(v)}` },
      { id: 'downlink', key: 'downlinkSignalPct', label: 'downlink', unit: '%', colour: 'var(--amber)', min: 0, max: 100, opacity: 0.9, fmt: (v) => `${Math.round(v)}` },
    ];
  }

  pipRows() {
    return this.flight.events
      .filter((e) => e.category === 'gps' || e.category === 'signal')
      .map((e) => ({ index: e.index, severity: e.severity }));
  }
}
